var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2588 15.1578C21.0596 14.5947 21.6601 13.7911 21.9731 12.8636C22.2862 11.9361 22.2955 10.933 21.9998 9.99982C21.3933 8.08482 19.5348 7.03532 17.5263 7.03732H16.3658C16.0889 5.95762 15.5706 4.95483 14.85 4.10443C14.1294 3.25403 13.2253 2.5782 12.2057 2.12781C11.1861 1.67743 10.0776 1.46423 8.96367 1.50427C7.84975 1.54431 6.75942 1.83654 5.77479 2.35897C4.79016 2.8814 3.93688 3.6204 3.2792 4.52034C2.62152 5.42028 2.17658 6.4577 1.97788 7.55449C1.77919 8.65128 1.83191 9.77886 2.13208 10.8523C2.43225 11.9258 2.97204 12.9172 3.71082 13.7518M12.0038 18.4998L11.9998 9.49982M15.1818 15.3178L11.9998 18.4998L8.81782 15.3178",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/IconDownload.0f092938cdb63d37e2612b7434faf550.svg";
export { ForwardRef as ReactComponent };